import { useCookies } from 'react-cookie'

import i18n from '../i18n'

export default () => {
  const [{ lang = 'en' }] = useCookies(['lang'])

  return i18n(lang)
}
